import React from 'react';
import PropTypes from 'prop-types';
import Formsy from './Formsy';
import FormStates from '../../constants/FormStates';

const isOneOf = (value, array) => !!(array.indexOf(value) + 1);
const {
    FORM_SAVING_SUCCESS,
    FORM_SAVING_FAILURE,
    FORM_PENDING_SAVING_SUCCESS,
    FORM_PENDING_SAVING_FAILURE
} = FormStates;

export default class FormsyForm extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        formStatus: PropTypes.string,
        hasExternalValidationErrors: PropTypes.bool,
        submitForm: PropTypes.func,
        invalidSubmit: PropTypes.func,
        errorMessages: PropTypes.object,
        callbackDelay: PropTypes.number,
        successCallback: PropTypes.func,
        formInstance: PropTypes.object
    };

    static defaultProps = {
        errorMessages: {}
    };

    componentDidUpdate() {
        const {
            hasExternalValidationErrors,
            errorMessages,
            formStatus,
            callbackDelay,
            successCallback
        } = this.props;

        if (isOneOf(formStatus, [FORM_SAVING_SUCCESS, FORM_PENDING_SAVING_SUCCESS])) {
            const setPristine = this.setPristine.bind(this);
            setTimeout(() => {
                setPristine(true);
                if (successCallback) {
                    successCallback();
                }
            }, callbackDelay);
        }
        if (isOneOf(formStatus, [FORM_SAVING_FAILURE, FORM_PENDING_SAVING_FAILURE])) {
            this.setPristine(false);
        }

        if (hasExternalValidationErrors) {
            this.updateInputsWithError(errorMessages);
            this.setPristine(false);
        }
    }

    /*
     * Formsy.Form methods:
     *  (other methods available @ https://github.com/christianalfoni/formsy-react/blob/master/API.md)
            this.setPristine(true);
     **/
    updateInputsWithError = errorMessages => {
        const {formInstance} = this.props;
        const formsyRef = formInstance.reference;
        if (!formsyRef) return;
        formsyRef.updateInputsWithError(errorMessages);
    };

    setPristine = pristineOption => {
        const {formInstance} = this.props;
        const formsyRef = formInstance.reference;
        if (!formsyRef) return;
        formsyRef.setFormPristine(pristineOption);
    };

    render() {
        const {submitForm, invalidSubmit} = this.props;
        return (
            <Formsy onValidSubmit={submitForm} onInvalidSubmit={invalidSubmit} noValidate>
                {this.props.children}
            </Formsy>
        );
    }
}
